import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <SectionHeading
          eyebrow="我们怎么做"
          title="一篇档案从线索到成稿，要走四步"
          desc="拆解比结论重要，方法比故事重要。这是我们判断值不值得写、怎么写的基本顺序。"
          align="center"
        />

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {processSteps.map((step, index) => (
            <li
              key={step.step}
              className="relative flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="font-heading text-3xl font-bold text-primary-500/40 mb-4">
                {step.step}
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              {index < processSteps.length - 1 && (
                <span className="hidden lg:flex absolute top-1/2 -right-3 z-10 w-6 h-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}